import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  DuplicateListResponse,
  DuplicateMembersResponse,
  DuplicateSummaryMetrics,
} from '../models/duplicate-business';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ManageDuplicatesService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiBaseUrl}/api/admin/duplicates`;

  getDuplicateSummary(): Observable<DuplicateSummaryMetrics> {
    return this.http.get<DuplicateSummaryMetrics>(`${this.baseUrl}/summary`, {
      headers: {
        'X-Skip-Loader': 'true',
      },
    });
  }

  getDuplicates(
    page = 1,
    pageSize = 10,
    search = '',
    identityType = 'all',
  ): Observable<DuplicateListResponse> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('page_size', pageSize.toString())
      .set('identity_type', identityType);

    if (search && search.trim()) {
      params = params.set('search', search.trim());
    }

    return this.http.get<DuplicateListResponse>(this.baseUrl, { params });
  }

  getIdentityMembers(
    identityType: string,
    identityValue: string,
    page = 1,
    pageSize = 5,
  ): Observable<DuplicateMembersResponse> {
    const params = new HttpParams()
      .set('identity_type', identityType)
      .set('identity_value', identityValue)
      .set('page', page.toString())
      .set('page_size', pageSize.toString());

    return this.http.get<DuplicateMembersResponse>(
      `${this.baseUrl}/identity-members`,
      { params },
    );
  }
}
